import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import actionFactory from 'Shared/hooks/actionFactory'
import { actions as localActionsF } from './local'

const adapter = createEntityAdapter()

const reducer = createSlice({
  name: 'answers',
  initialState: adapter.getInitialState(),
  reducers: {
    upsert: adapter.upsertOne,
    add: adapter.addOne,
    set: adapter.setOne,
    setAll: adapter.setAll,
    remove: adapter.removeOne,
    updateAnswerTextContent: (state, action) => {
      const { answerId, language, key, value } = action.payload
      state.entities[answerId].textContent ||= {}
      state.entities[answerId].textContent[language] ||= {}
      state.entities[answerId].textContent[language][key] = value
    },
    setAllSetsGoalIdsNull: (state) => {
      _.values(state.entities).forEach(answer => {
        if (answer.setsGoalId) {
          answer.setsGoalId = null
        }
      })
    }
  },
}).reducer

const actions = (dis, store, restClient) => {
  const localActions = localActionsF(dis, store, restClient)
  const factoryActions = actionFactory(dis, store, 'answer', {}, {
    add: (dis, store, entity) => (data = {}) => {
      const id = uuidv4()
      const state = store.getState()
      const digitOrderMax = _.max(_.values(state.answers.entities).filter(a => a.active).map(q => q.digitOrder))
      const digitOrder = isNaN(digitOrderMax) ? 1 : digitOrderMax + 1
      dis({ type: `answers/upsert`, payload: { id, digitOrder, active: true, nextQuestionId: null, setsGoalId: null, action: 'next_question', ...data } })
      localActions.setDirty(true)
    },
    markInactive: (dis, store, entity) => (id) => {
      dis({ type: `answers/upsert`, payload: { id, active: false } })
      localActions.setDirty(true)
    }
  }, {
    afterChange: () => localActions.setDirty(true)
  })

  function updateAnswerTextContent({answerId, language, key, value}) {
    const state = store.getState()
    dis({ type: 'answers/updateAnswerTextContent', payload: { answerId, language, key, value } })
    if ((language == (state?.builder?.flow?.defaultLanguage || 'en')) && key == 'answer') { //If default flow language, update the 'official' answer (for exports etc.)
      dis({ type: 'answers/upsert', payload: { id: answerId, answer: value } })
    }
    localActions.setDirty(true)
  }

  function setAllSetsGoalIdsNull() {
    dis({ type: 'answers/setAllSetsGoalIdsNull' })
    localActions.setDirty(true)
  }

  return {
    ...factoryActions,
    updateAnswerTextContent,
    setAllSetsGoalIdsNull,
  }
}

export { reducer, actions }
export default { reducer, actions }
